(function () {
    interface ValidatorMetaData {
        model?: { message?: string };
    }

    interface ValidationResult {
        isValid: boolean;
        message: string;
    }

    type ValidateFunction = (
        fieldName: string,
        fieldValue: string,
        validatorMetaData: ValidatorMetaData | null
    ) => ValidationResult | true;

    interface ValidatorObject {
        validate: ValidateFunction;
    }

    interface EpiWindow extends Window {
        epi?: {
            EPiServer?: {
                Forms?: {
                    Validators?: Record<string, ValidatorObject | ValidateFunction>;
                };
            };
        };
    }

    const NAME_PATTERN = /^(?=.*\p{L})[\p{L}\p{M}]+(?:[ '-][\p{L}\p{M}]+)*$/u;

    const epiWindow = window as EpiWindow;
    epiWindow.epi = epiWindow.epi || {};
    epiWindow.epi.EPiServer = epiWindow.epi.EPiServer || {};
    epiWindow.epi.EPiServer.Forms = epiWindow.epi.EPiServer.Forms || {};
    epiWindow.epi.EPiServer.Forms.Validators = epiWindow.epi.EPiServer.Forms.Validators || {};

    const validators = epiWindow.epi.EPiServer.Forms.Validators;

    const keyPascal = "Securitas.PublicWeb.Web.Models.Elements.LettersOnlyValidator";
    const keyLower = keyPascal.toLowerCase();

    function coreValidate(_fieldName: string, fieldValue: string, validatorMetaData: ValidatorMetaData | null): ValidationResult | true {
        const errorMessage =
            validatorMetaData?.model?.message ||
            "Please enter letters only. Allowed separators: space, apostrophe, hyphen.";

        // Empty -> RequiredValidator
        if (fieldValue === null || fieldValue === undefined || fieldValue.length === 0) {
            return true;
        }

        // Reject if the value is only whitespace
        if (fieldValue.trim().length === 0) {
            return { isValid: false, message: errorMessage };
        }

        if (!NAME_PATTERN.test(fieldValue.trim())) {
            return { isValid: false, message: errorMessage };
        }

        return true;
    }

    const validatorObject: ValidatorObject = { validate: coreValidate };
    validators[keyLower] = validatorObject;
    validators[keyPascal] = validatorObject;
    validators[keyLower + ":fn"] = coreValidate;
    validators[keyPascal + ":fn"] = coreValidate;
})();